export default "__VITE_ASSET__CuUC00mf__"